// Translations
import modelTransaction from '../components/model-transaction/translations/en'

// Translation: Account > Billing > Recurring transactions (English)
export default Object.freeze({
	components: { modelTransaction },
	fallback: {
		empty: 'No transactions found.',
		unavailable: 'Information is not available.'
	},
	title: 'Recurring transaction history',
	transactionTypeItems: {
		ASSET_HOSTING: 'Asset hosting',
		ASSET_REFUND: 'Asset refund',
		ASSET_USAGE: 'Asset usage',
		AUTO_TOP_UP: 'Auto top up',
		EXPIRABLE_CREDIT: 'Expirable credit',
		PAY_OUT: 'Pay out',
		RESERVE_ASSET_USAGE: 'Reserve asset usage',
		SERVICE_ASSET_USAGE: 'Service asset usage',
		SUBSCRIPTION: 'Subscription',
		TOP_UP: 'Top up',
		TRANSFER: 'Transfer',
		TRIAL_TOP_UP: 'Trail top up',
		UNSUBSCRIBE: 'Unsubscribe'
	}
})
